import { useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'
import { Script } from '@calendly/react-script-tag'
import { SafeSuspense } from '@calendly/safe-suspense'

import { useIsAnalyticsAllowed } from 'hooks/useIsAnalyticsAllowed'
import { isEmbeddedSelector } from 'selectors/embed'
import { Settings } from 'services/settings'

const setupApi = (isEmbedded) => {
  if (!window.fbq) {
    const fbq = (...args) => {
      if (fbq.callMethod) {
        fbq.callMethod(...args)
      } else {
        fbq.queue.push(args)
      }
    }
    fbq.push = fbq
    fbq.loaded = !0
    fbq.version = '2.0'
    fbq.queue = []

    // disable PageView Event on Browser History Changes for Embedded Flow
    // https://developers.facebook.com/docs/marketing-api/audiences-api/pixel/
    if (isEmbedded) {
      fbq.disablePushState = true
    }

    window.fbq = fbq
    Object.defineProperty(window, '_fbq', { value: window.fbq })
  }
}

export const FacebookPixelScript = () => {
  const isEmbedded = useSelector(isEmbeddedSelector)
  const isAllowed = useIsAnalyticsAllowed() && Settings.facebook_pixel.enabled === true

  useLayoutEffect(() => {
    setupApi(isEmbedded)
  }, [isEmbedded])

  if (!isAllowed) return null

  return (
    <SafeSuspense fallback={null} onError={null}>
      <Script data-testid="facebook-pixel-script" src="https://connect.facebook.net/en_US/fbevents.js">
        {null}
      </Script>
    </SafeSuspense>
  )
}
